module.exports = __webpack_public_path__ + "img/50x50_turuncu.09963748.gif";